// extracted by mini-css-extract-plugin
export default {"font-list":"FontSettings_font-list__UsB8h","loading-wrapper":"FontSettings_loading-wrapper__8RWDw"};